import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Alerte() {
  const navigate = useNavigate();
  const [notificari, setNotificari] = useState([]);
  const [incarca, setIncarca] = useState(true);

  const taburi = [
    { nume: 'Gestioneaza anunturile', link: '/anunturile-mele', activ: false },
    { nume: 'Comenzile mele', link: '/comenzi', activ: false },
    { nume: 'Mesaje', link: '/mesaje', activ: false },
    { nume: 'Favorite', link: '/favorite', activ: false },
    { nume: 'Alertele mele', link: '/alerte', activ: true },
    { nume: 'Detaliile mele', link: '/setari', activ: false }
  ];

  useEffect(function() {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }
    incarcaNotificari(token);
  }, [navigate]);

  async function incarcaNotificari(token) {
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/notificari/mele', {
        headers: { 'x-auth-token': token }
      });
      if (raspuns.ok) {
        const date = await raspuns.json();
        setNotificari(date);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIncarca(false);
    }
  }

  async function marcheazaToteCitite() {
    const token = localStorage.getItem('token');
    try {
      await fetch('https://tranzitio.onrender.com/api/notificari/toate/citite', {
        method: 'PUT',
        headers: { 'x-auth-token': token }
      });
      const notificariNoi = [];
      for (let i = 0; i < notificari.length; i++) {
        const notificareNoua = { ...notificari[i], citita: true };
        notificariNoi.push(notificareNoua);
      }
      setNotificari(notificariNoi);
    } catch (err) {
      console.log(err);
    }
  }

  async function marcheazaCitita(id) {
    const token = localStorage.getItem('token');
    try {
      await fetch('https://tranzitio.onrender.com/api/notificari/' + id + '/citita', {
        method: 'PUT',
        headers: { 'x-auth-token': token }
      });
      const notificariNoi = [];
      for (let i = 0; i < notificari.length; i++) {
        if (notificari[i]._id === id) {
          notificariNoi.push({ ...notificari[i], citita: true });
        } else {
          notificariNoi.push(notificari[i]);
        }
      }
      setNotificari(notificariNoi);
    } catch (err) {
      console.log(err);
    }
  }

  function getIconNotificare(tip) {
    if (tip === 'comanda') {
      return (
        <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center shrink-0">
          <svg className="w-5 h-5 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          </svg>
        </div>
      );
    }
    if (tip === 'mesaj') {
      return (
        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center shrink-0">
          <svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
          </svg>
        </div>
      );
    }
    return (
      <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center shrink-0">
        <svg className="w-5 h-5 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
        </svg>
      </div>
    );
  }

  let necitite = 0;
  for (let i = 0; i < notificari.length; i++) {
    if (!notificari[i].citita) {
      necitite = necitite + 1;
    }
  }

  return (
    <div className="min-h-screen bg-[#f3f4f6]">
      <div className="bg-white border-b border-gray-200 overflow-x-auto">
        <div className="max-w-7xl mx-auto px-4 flex min-w-max">
          {taburi.map(function(tab, index) {
            let clasa = 'flex items-center gap-2 px-6 py-4 text-sm font-bold transition-all border-b-4 ';
            if (tab.activ) {
              clasa = clasa + 'border-blue-600 text-blue-700';
            } else {
              clasa = clasa + 'border-transparent text-gray-500 hover:text-gray-800 hover:bg-gray-50';
            }
            return (
              <Link key={index} to={tab.link} className={clasa}>
                {tab.nume}
              </Link>
            );
          })}
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-xl font-bold text-gray-800">Notificarile tale</h2>
            {necitite > 0 && (
              <p className="text-sm text-gray-500 mt-0.5">{necitite} necitite</p>
            )}
          </div>
          {necitite > 0 && (
            <button
              onClick={marcheazaToteCitite}
              className="text-sm font-bold text-blue-600 hover:text-blue-800 bg-blue-50 hover:bg-blue-100 px-4 py-2 rounded-lg transition"
            >
              Marcheaza toate ca citite
            </button>
          )}
        </div>

        {incarca ? (
          <div className="flex justify-center py-20">
            <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
          </div>
        ) : notificari.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-24 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center mb-6">
              <svg className="w-12 h-12 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </div>
            <h3 className="text-2xl font-black text-gray-800 mb-2">Nicio notificare</h3>
            <p className="text-gray-500 font-medium text-center max-w-sm">
              Vei fi notificat aici cand primesti mesaje, comenzi sau recenzii.
            </p>
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {notificari.map(function(n) {
              let clasaCard = 'bg-white rounded-xl border p-4 flex items-start gap-4 transition cursor-pointer hover:shadow-md ';
              if (!n.citita) {
                clasaCard = clasaCard + 'border-blue-200 shadow-sm';
              } else {
                clasaCard = clasaCard + 'border-gray-100 opacity-70';
              }

              let clasaTitlu = 'font-bold text-gray-900';
              if (n.citita) {
                clasaTitlu = 'font-medium text-gray-900';
              }

              return (
                <div
                  key={n._id}
                  onClick={function() {
                    if (!n.citita) {
                      marcheazaCitita(n._id);
                    }
                  }}
                  className={clasaCard}
                >
                  {getIconNotificare(n.tip)}
                  <div className="flex-grow min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <p className={clasaTitlu}>{n.titlu}</p>
                      {!n.citita && (
                        <span className="w-2.5 h-2.5 bg-blue-500 rounded-full shrink-0 mt-1.5"></span>
                      )}
                    </div>
                    <p className="text-sm text-gray-600 mt-1 leading-relaxed">{n.mesaj}</p>
                    <p className="text-xs text-gray-400 mt-2 font-medium">
                      {new Date(n.data).toLocaleDateString('ro-RO', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Alerte;